import {
  BaseListItem,
  BaseListPager,
  Wireframe
} from '@did/das-balance-components'
import { useAccountList } from '@did/das-balance-hooks'
import { MyAccountListType } from '@did/das-balance-types/modules'
import React, { useEffect } from 'react'
import { HistoryItem } from './history-item'
import styles from './styles.module.scss'
import { useDasBalanceContext } from '@did/das-app-context'

export const MyAccountList: MyAccountListType = ({
  balance,
  NotFound,
  className
}) => {
  const { tt } = useDasBalanceContext()
  const { accounts, loading, currPage, setCurrPage, pages, fetchData } =
    useAccountList()

  useEffect(() => {
    fetchData()
  }, [balance])

  return (
    <div className={`${styles.accountList} ${className}`}>
      {loading &&
        Array.from({ length: 10 }).map((_, i) => (
          <BaseListItem
            key={i}
            className={styles.listItem}
            head={<Wireframe shape="circle" height="24" width="24" />}
            tail={<Wireframe shape="round" height="20" width="100" />}
          >
            <Wireframe shape="round" height="20" width="100" />
          </BaseListItem>
        ))}

      {!loading &&
        accounts.length > 0 &&
        accounts.map((account, i) => <HistoryItem key={i} account={account} />)}
      {!loading && !accounts.length && (
        <NotFound title={tt('No records')} className=" pb-14 my-8 " />
      )}
      {pages > 1 && (
        <BaseListPager
          className={styles.baseListPager}
          current={currPage}
          pages={pages}
          onChange={setCurrPage}
          noItems
        />
      )}
    </div>
  )
}
